import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { TwelveMonthRevenueInsightsEntity } from "../entities/TwelveMonthRevenueInsightsEntity";

export class GetTwelveMonthRevenueInsightsUseCase {
  constructor(private repository: ClientOverviewRepository) {}

  async execute(): Promise<TwelveMonthRevenueInsightsEntity> {
    return this.repository.getTwelveMonthRevenueInsights();
  }
}
